import { render } from "./ModalPage.vue?vue&type=template&id=1c41b2e8&ts=true"
import script from "./ModalPage.vue?vue&type=script&lang=ts"
export * from "./ModalPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__